import React from 'react';
import {useTranslation} from 'react-i18next';
import {
  Container,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import background from 'assets/images/bg/partner-ship.png';
import partnership from 'assets/images/partnership.png';

const PartnerShip = () => {
  const {t} = useTranslation();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('md'));

  const classes = useStyles();
  return (
    <Container maxWidth="md">
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        className={classes.root}>
        <div className={classes.container}>
          <Typography
            variant="h3"
            style={{
              fontWeight: 'bold',
              color: '#375235',
              fontSize: 35,
              marginTop: 20,
            }}>
            Partnership
          </Typography>
          <Typography>BEST Partners</Typography>
          <img
            src={partnership}
            alt="#"
            onClick={() => window.open('https://www.alpacafinance.org')}
            style={{maxWidth: '100%', marginTop: 16, cursor: 'pointer'}}
          />
        </div>
      </Grid>
    </Container>
  );
};
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundImage: `url("${background}")`,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% 100%',
    height: 270,
    marginTop: theme.spacing(12),
    [theme.breakpoints.down('xs')]: {
      height: 200,
    },
  },
  container: {
    height: 200,
    border: '2px solid #365038',
    backgroundColor: '#fff',
    width: '80%',
    textAlign: 'center',
    [theme.breakpoints.down('xs')]: {
      height: 150,
    },
  },
}));
export default PartnerShip;
